import {useMutation, useQueryClient} from 'react-query'
import {Settings} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";

const onMutateSuccess = (values: Settings) => {
    showNotification({
        title: 'Contact properties updated',
        icon: <Check/>,
        message: `The contact properties have been updated!`,
    });
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while updating the contact properties. ${error}`,
        color: 'red'
    });
}

export default function useMutateContactPropertyData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload contact properties data
            queryClient.invalidateQueries(['contactProperties']);

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
